import React from 'react';
import cx from 'classnames';

import s from './index.module.css';

const UserIcon = ({ className, isOnline, icon }) => (
  <div
    className={cx(s.icon, { [className]: !!className, [s.isOnline]: isOnline })}
    style={{ backgroundImage: `url(${icon})` }}
  />
);

export default UserIcon;
